import { useEffect } from 'react';
import Menu from '../../../commons/Menu/Menu';

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Menu />
      <div style={{ padding: 8 }}>
        <p style={{ whiteSpace: 'pre-line' }}>
          Politique de référencement <br />
          <br />
          POLITIQUE DE RÉFÉRENCEMENT <br />
          La présente politique de référencement expose les modalités de référencement, de
          déréférencement et de classement sur la plateforme Publiconsult <br />
          <br />
          Clause n°1 : Règles applicables pour être référencé <br />
          Les entreprises qui souhaitent être référencées doivent obligatoirement souscrire à un
          abonnement payant. L’abonnement a une durée de 365 jours à compter de la date de paiement.
          Son apparition dans l’annuaire en tant qu’entreprise est réalisée sous 48h maximum. <br />
          L’abonnement est activé pour une durée de 365 jour calendaire à compter du paiement de la
          commande. Passé ce délai, le Client devra procéder à une nouvelle commande pour réactiver
          son offre. Le Client n’est pas réengagé automatiquement. <br />
          Clause n°2 : Obligations dont le non-respect conduit à être déréférencé <br />
          L’entreprise fournit lors de la souscription à son abonnement tous les éléments en sa
          possession pour réaliser un référencement correspondant à la réalité de son identité et de
          son fonctionnement. <br />
          Le déréférencement pourra être appliqué à tout moment, sans préavis et sans remboursement
          possible dans les cas suivants : <br />- Passage de l’entreprise du Client en liquidation
          judiciaire ou fermeture de la société <br />
          - Non-respect de la catégorie sélectionnée en fonction du nombre de salariés dans
          l’entreprise au moment de l’inscription <br />
          Clause n°3 : Critères de classement <br />
          Les entreprises seront classées par défaut par ordre alphabétique. Si le nom commercial de
          l’entreprise débute par un nombre, alors elle sera placée avant le début de l’alphabet.
          Les entreprises seront donc classées de 0 à infini, puis d’A à Z. <br />
          Il sera possible de créer une sélection de critères sur les éléments suivants : classement
          par département, classement par domaine d’activités. Si une sélection est activée, le
          classement par défaut reste le même ; à savoir, ordre alphabétique comme énoncé ci-dessus.{' '}
          <br />
          Clause n°4 : Relations entre l’opérateur de plateforme et les offreurs référencés <br />
          Aucune rémunération n’influence le référencement ou le classement des contenus.
        </p>
      </div>
    </>
  );
};
